import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { ClientPolicyDto } from '@core/pages/new-business-register/api'

const clientPolicyStore = namespace('ClientPolicyStore')

@Component
export default class SubPolicyMixin extends Vue {
  @clientPolicyStore.State
  subPolicies: ClientPolicyDto[]

  @clientPolicyStore.Action
  retrieveSubPolicies

  protected retrieveSubPoliciesProductOids (): string[] {
    return this.subPolicies.map(policy => {
      return policy.productOid
    })
  }
}
